module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"headTitle":"Prijsklasse woning","headDescription":"Geef aan om welke prijsklasse en wat voor type woning het gaat waarmee de makelaar je kan helpen.","title":"Prijsklasse","nextBtn":"Volgende","subtext":"Gratis & volledig vrijblijvend"}}')
  delete Component.options._Ctor
}
